var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 8.66634V3.88301L3.61699 5.59968L2.66699 4.66634L6.00033 1.33301L9.33366 4.66634L8.38366 5.59968L6.66699 3.88301V8.66634H5.33366ZM10.0003 14.6663L6.66699 11.333L7.61699 10.3997L9.33366 12.1163V7.33301H10.667V12.1163L12.3837 10.3997L13.3337 11.333L10.0003 14.6663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.f9d9056ae770c5dbd37724911538b2d9.svg";
export { ForwardRef as ReactComponent };